import Div100vh from 'react-div-100vh';

import {BackgroundImage} from '@/ui/common/BackgroundImage/BackgroundImage';
import {CustomPreloader} from '@/ui/kit/CustomPreloader/CustomPreloader';

import s from './LoaderPageMb.module.css';

export function LoaderPageMb(): JSX.Element {
  return (
    <Div100vh className={s.wrapper}>
      <BackgroundImage />
      <div className={s.preloaderContainer}>
        <CustomPreloader />
      </div>
    </Div100vh>
  );
}
